import React, { Children } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { ProductCard } from './ProductCard';
import { PRODUCTS } from './products';
import { Button } from './ui/Button';
export function FeaturedProducts() {
  const featured = PRODUCTS.filter(p => ['bpc-157', 'semaglutide', 'ghk-cu', 'nad-plus'].includes(p.id));
  return <section className="w-full py-20 lg:py-28 border-t border-border" data-id="element-158">
      <div className="container mx-auto" data-id="element-159">
        <div className="flex items-end justify-between gap-6 mb-12" data-id="element-160">
          <motion.div initial={{
          opacity: 0,
          y: 12
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-80px'
        }} transition={{
          duration: 0.5
        }} data-id="element-161">
            <p className="text-[11px] uppercase tracking-wider text-muted-foreground font-medium mb-3" data-id="element-162">
              The catalogue
            </p>
            <h2 className="text-3xl lg:text-5xl font-semibold tracking-[-0.025em] text-foreground max-w-xl leading-[1.05]" data-id="element-163">
              Featured peptides this month
              <span className="text-primary" data-id="element-164">.</span>
            </h2>
          </motion.div>
          <Button asChild variant="ghost" className="rounded-full hidden md:inline-flex group" data-id="element-165">
            <Link to="/shop" data-id="element-166">
              View all
              <ArrowRight className="h-4 w-4 ml-1 transition-transform group-hover:translate-x-0.5" data-id="element-167" />
            </Link>
          </Button>
        </div>

        <motion.div initial="hidden" whileInView="show" viewport={{
        once: true,
        margin: '-80px'
      }} variants={{
        hidden: {},
        show: {
          transition: {
            staggerChildren: 0.08
          }
        }
      }} className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5" data-id="element-168">
          {featured.map(product => <motion.div key={product.id} variants={{
          hidden: {
            opacity: 0,
            y: 16
          },
          show: {
            opacity: 1,
            y: 0,
            transition: {
              duration: 0.45,
              ease: [0.22, 1, 0.36, 1]
            }
          }
        }} data-id="element-169">
              <ProductCard product={product} data-id="element-170" />
            </motion.div>)}
        </motion.div>
        <div className="md:hidden mt-8 flex justify-center" data-id="element-171">
          <Button asChild variant="outline" className="rounded-full" data-id="element-172">
            <Link to="/shop" data-id="element-173">View all peptides</Link>
          </Button>
        </div>
      </div>
    </section>;
}